exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".daterange-picker{border:1px solid #e8e8e8;border-radius:3px;padding:7px 5px 5px;background:#fff;color:#333;max-width:310px;font-size:14px}.vdp-datepicker input{border:none;text-align:center;margin-left:2px;width:100px}.vdp-datepicker{max-width:180px;margin-left:5px;margin-right:5px;float:left}.vdp-datepicker .cell.day.today{border-color:#ff0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-037912cb!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DateRangePicker.vue
// module id = 835
// module chunks = 2